export const UNITS = ["g", "kg", "mg", "lbs", "oz", "mL", "L", "µL", "mol", "mmol", "Pack", "Kit"] as const;

export type Unit = (typeof UNITS)[number];
